import { createReducer, on, Action } from "@ngrx/store";
import * as actions from "./actions";
export { actions as Actions };
import { UserState } from "./state";
export * from "./state";

export interface featureState extends UserState {
    error: string | null;
}

export const userStateFeatureKey = "userState";

const initialUserInfo: UserState = {
    name: null,
    idTokenClaims: null,
    username: null,
    loggedIn: false,
    error: null,
};

const UserStateSubReducer = createReducer(
    initialUserInfo,
    on(actions.loginSuccess, (s, { name, username }) => {
        return {
            ...s,
            name: name,
            username: username,
            loggedIn: true,
        };
    }),
    on(actions.loginFailure, (s, { error }) => {
        return {
            ...s,
            loggedIn: false,
            error: error,
        };
    }),
    on(actions.loginToken, (s, { id_token, access_token, idTokenClaims }) => {
        return {
            ...s,
            id_token,
            access_token,
            idTokenClaims,
        };
    }),
    on(actions.logoutSuccess, (s, payoload) => {
        return initialUserInfo;
    }),
);

export function UserReducer(state: featureState, action: Action) {
    return UserStateSubReducer(state, action);
}
